var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavHomeIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 18.9429V9.68571C4 9.36 4.071 9.05143 4.213 8.76C4.355 8.46857 4.55067 8.22857 4.8 8.04L10.8 3.41143C11.15 3.13714 11.55 3 12 3C12.45 3 12.85 3.13714 13.2 3.41143L19.2 8.04C19.45 8.22857 19.646 8.46857 19.788 8.76C19.93 9.05143 20.0007 9.36 20 9.68571V18.9429C20 19.5086 19.804 19.993 19.412 20.3962C19.02 20.7994 18.5493 21.0007 18 21H15C14.7167 21 14.4793 20.9013 14.288 20.7038C14.0967 20.5063 14.0007 20.2622 14 19.9714V14.8286C14 14.5371 13.904 14.293 13.712 14.0962C13.52 13.8994 13.2827 13.8007 13 13.8H11C10.7167 13.8 10.4793 13.8987 10.288 14.0962C10.0967 14.2937 10.0007 14.5378 10 14.8286V19.9714C10 20.2629 9.904 20.5073 9.712 20.7048C9.52 20.9023 9.28267 21.0007 9 21H6C5.45 21 4.97933 20.7987 4.588 20.3962C4.19667 19.9937 4.00067 19.5093 4 18.9429Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavHomeIco);
export default __webpack_public_path__ + "static/media/Nav_home_ico.54aaaa26890af4097fa21283d32895e1.svg";
export { ForwardRef as ReactComponent };